<app-table [config]="tableConfig" />
